'use strict';

import React from 'react';

class StripeConnectedConfirmation extends React.Component {
  componentDidMount(){
    const isSuccess = this.isSuccess.bind(this)();

    if(isSuccess && !this.props.stripeCredentialsPassed){
      const authCode = this.getQueryVariable('code');
      const scope = this.getQueryVariable('scope');
      this.props.actions.paymentActions.stripePassCredentials(authCode, scope);
    }
  }

  isSuccess(){
    let url = window.location.href;
    if(url && url.includes && url.includes('code=')) return true;
    return false;
  }

  getQueryVariable(key){
    var query = window.location.search.substring(1);
    var result = null;
    var vars = query.split('&');
    for (var i=0;i<vars.length;i++) {
      var pair = vars[i].split('=');
      if(pair[0] == key){
        result = pair[1];
        return pair[1];
      }
    }
    return result;
  }

  render() {
    if(this.isSuccess.bind(this)()){
      return (
        <div className='stripe-connected-confirmation-container flex-column align-center flex-center'>
          <img src={require('../../images/confirmationCheckmark.png')} className='confirmation-checkmark' />
          <img src={require('../../images/trybeStripeConnected.png')} className='trybe-stripe-connected'/>

          <div className='confirmation-text'>
            Thank you for completing the payment setup. Stripe has been successfully connected, and you should now receive payments automatically.
          </div>
        </div>
      );
    } else {
      const errorDescr = this.getQueryVariable.bind(this)('error_description');
      const errorReadable = errorDescr ? errorDescr.replace(/%20/g, ' ') : null;
      return (
        <div className='stripe-connected-confirmation-container flex-column align-center flex-center'>
          <img src={require('../../images/error.png')} className='error-img' />

          <div className='confirmation-text'>
            Uh oh. Looks like an error occured while trying to connect your Stripe account with Trybe.
          </div>

          { errorReadable ?
            <div className='confirmation-text'>FYI, here's a clue about what wrong: "{errorReadable}". This may come in handy when trying to fix the issue.</div>
            : null
          }

          <div className='confirmation-text'>
            Please email with support@trybe.do for assistance so we can finish setting this up for you.
          </div>
        </div>
      );
    }

  }
}

StripeConnectedConfirmation.displayName = 'StripeConnectedConfirmation';

export default StripeConnectedConfirmation;



// WEBPACK FOOTER //
// ./src/components/pages/StripeConnectedConfirmation.js